import React, { useState, useContext, useMemo, useEffect} from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  TextField,
  Button,
  FormControlLabel,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Toolbar,
  Skeleton,
  Alert,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { Settings, FilterList, Search, ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
// import { AuthContext } from './AuthContext';
import {ALUMNOSLIST_URL, LOGOUT_URL} from '../apiConfig'; 
import AdminModal from './AdminModal';
import { use } from 'react';
// import { fieldLabels } from '../utils/fieldLabels'; // Asegúrate de tener este archivo con los labels de los campos
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import {Pagination} from 'react-bootstrap';
import debounce from 'lodash.debounce';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Pass } from 'react-bootstrap-icons';
import ConfigurationModal from './ConfigurationModal';

dayjs.extend(utc);

const fieldLabels = {
  nombre: 'Nombre',
  apellido: 'Apellido',
  pausado: 'Pausado',
  inicio_acceso: 'Inicio de Acceso',
  expiracion: 'Expiración',
  dias_restantes: 'Días Restantes',
  proximo_pago: 'Próximo Pago',
  ultimo_pago: 'Último Pago',
  total_pagado: 'Total Pagado',
  pais: 'País',
  whatsapp: 'WhatsApp',
  email_importado: 'Correo', 
  encuesta: 'Encuesta',
  observaciones: 'Observaciones',
  call_previa_nils: 'Call Previa Nils',
  otro_telefono: 'Teléfono Alternativo',
  ssm: 'SSM',
  nivel: 'Nivel',
  nicho: 'Nicho',
  clientes_inicio: 'Clientes Iniciales',
  clientes_conseguidos: 'Clientes Conseguidos',
  ingresos_mensuales: 'Ingresos Mensuales',
  id: 'ID',
  username_importado: 'Usuario Milkiforma',
  activo: 'Activo',
  fecha_pausado: 'Fecha Pausado',
  fecha_reactivacion: 'Fecha Reactivación',
  trimestre: 'Trimestre',
  grupo: 'Grupo'
};
// Campos predefinidos por rol
const SUPERVISOR_FIELDS = ['id', 'nombre', 'apellido', "pausado", 'inicio_acceso', 'expiracion', 'dias_restantes', 'pais', 'nivel', 'username_importado', 'activo',
    'encuesta', 'fecha_pausado', 'fecha_reactivacion', 'trimestre', 'grupo'
 ];
const ADMIN_FIELDS = [
  'nombre', 'apellido', "pausado", 'inicio_acceso', 'expiracion', 'dias_restantes', 'proximo_pago', 'ultimo_pago', 'total_pagado',
   'pais', 'whatsapp', 'otro_telefono', 'email_importado', 'encuesta', 'observaciones', 'call_previa_nils', 'ssm',
   'clientes_inicio', 'ingresos_mensuales','clientes_conseguidos',  'nivel', 'id', 'username_importado', 'nicho', 
   'activo', 'fecha_pausado', 'fecha_reactivacion', 'trimestre', 'grupo'
];


const AlumnosList = ({  }) => { // 3. Recibe el rol como prop
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  const [userRole, setUserRole] = useState('supervision'); // Estado para el rol del usuario

  useEffect(() => {
    setUserRole(localStorage.getItem('is_administrator') === 'true' ? 'admin' : 'supervision') // Determina el rol del usuario
    // console.log ('userRole:', userRole); // Verifica el rol del usuario en la consola

  }, [localStorage.getItem('is_administrator')]); 

  const [selectedFields, setSelectedFields] = useState(() => {
    const storedFields = JSON.parse(localStorage.getItem('selectedFields'));
    return storedFields && storedFields.length > 0 ? storedFields : SUPERVISOR_FIELDS;
  });
  
  // 1. Inicializa con campos por defecto
  
  const [modalOpen, setModalOpen] = useState(false); // Estado para controlar el modal
  const [selectedAlumno, setSelectedAlumno] = useState(null); // Estado para el alumno seleccionado
  const [selectedAlumnoId, setSelectedAlumnoId] = useState(null); // Estado para el ID del alumno seleccionado
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();


  const [filters, setFilters] = useState({
    status: 'active',  // 'active', 'inactive', 'all'
    showPaused: 'all',  // 'active', 'paused', 'all'
    group: 'all',
    trimester: 'all',
    search: '',
    ordering: '-expiracion',
    page: 1,
    page_size: pageSize
  });

  const hasActiveFilters = filters.search || 
  filters.status !== 'active' || 
  filters.showPaused !== 'all' ||
  filters.group !== 'all'||
  filters.trimester !== 'all';

  const [configurationModalOpen, SetConfigurationModalOpen] = useState(false);
  const [tempSelectedFields, setTempSelectedFields] = useState([]); // Nuevo estado temporal

  // 4. Determinar campos disponibles basados en el rol
  // console.log('userRole:', userRole);
  const availableFields = useMemo(() => 
    userRole === 'supervision' ? SUPERVISOR_FIELDS : ADMIN_FIELDS
  , [userRole]);

  // Inicializar campos seleccionados
  useEffect(() => {
    const storedFields = JSON.parse(localStorage.getItem('selectedFields')) || SUPERVISOR_FIELDS;
    const sortedFields = Object.keys(fieldLabels).filter(field => storedFields.includes(field));
    const fieldsWithId = sortedFields.includes('id') ? sortedFields : ['id', ...sortedFields];
    setSelectedFields(fieldsWithId.length > 0 ? fieldsWithId : availableFields);
  }, [availableFields]);

  const handleLogout = async () => {
    localStorage.removeItem('token');
    localStorage.removeItem('selectedDate');
    localStorage.removeItem('isSupervisor');
    try {
        await axios.post(LOGOUT_URL, null, { headers: { Authorization: `Token ${localStorage.getItem('token')}` } });
    } catch (error) {
      if (error.response && error.response.status === 401) {
      }
      else {
        console.error('Error logging out:', error);
      }
    } finally {
        navigate('/');
    }
};

// Lógica para construir los parámetros de la API
  const buildApiParams = () => {
    const params = {
      search: filters.search,
      ordering: filters.ordering,
      page: currentPage,
      page_size: pageSize
    };

    // Filtro de estado activo/inactivo
    if (filters.status !== 'all') {
      params.activo = filters.status === 'active';
    }

    // Filtro de pausados
    if (filters.showPaused === 'paused') {
      params.pausado = true; 
    } else if (filters.showPaused === 'active') {
      params.pausado = false; 
    }
    if (filters.group !== 'all'){
      params.grupo = filters.group
    }
    if (filters.trimester !== 'all'){
      params.trimestre = filters.trimester
    }
    return params;
  };

  // Fetch alumnos con debounce
  const fetchAlumnos = async () => {
    const apiParams = buildApiParams();
    const params = new URLSearchParams();
    const fieldsWithId = selectedFields.includes('id') ? selectedFields : ['id', ...selectedFields];
    fieldsWithId.forEach(field => params.append('fields', field));
    Object.entries(apiParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });
    try {
      const response = await axios.get(`${ALUMNOSLIST_URL}?${params}`, {
      headers: { Authorization: `Token ${localStorage.getItem('token')}` }
    });
    setTotalCount(response.data.count);
    return response.data;
    }
    catch (error) {
      if (error.response && error.response.status === 401) {
        // Si la respuesta es 401, redirigir al login
        console.error('Unauthorized access - redirecting to login');
        toast.error('Sesión expirada. Por favor, inicia sesión de nuevo.');
        handleLogout();
      }
      else { 
        console.error('Error fetching alumnos:', error);
        toast.error('Error al cargar los alumnos. Por favor, inténtalo de nuevo más tarde.'); 
      }
    }
  };

  
  const { data: alumnoCompleto, isLoading: isLoadingAlumno } = useQuery({
    queryKey: ['alumno', selectedAlumnoId],
    queryFn: () => fetchAlumnoCompleto(selectedAlumnoId),
    enabled: !!selectedAlumnoId,  // Solo ejecutar cuando hay un ID seleccionado
    staleTime: 30000
  });

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['alumnos', filters, selectedFields, currentPage, pageSize],
    queryFn: fetchAlumnos,
    keepPreviousData: true,
    staleTime: 30000
  });

  const fetchAlumnoCompleto = async (alumnoId) => {
    try{
    const response = await axios.get(`${ALUMNOSLIST_URL}${alumnoId}/`, {
      headers: { Authorization: `Token ${localStorage.getItem('token')}` }
    });
    // console.log('Alumno completo:', response.data);
    return response.data;}
    catch (error) {
      if (error.response && error.response.status === 401) {
        // Si la respuesta es 401, redirigir al login
        console.error('Unauthorized access - redirecting to login');
        toast.error('Sesión expirada. Por favor, inicia sesión de nuevo.');
        handleLogout();
      }
      else { 
        console.error('Error fetching alumnos:', error);
        toast.error('Error al cargar los alumnos. Por favor, inténtalo de nuevo más tarde.'); 
      }
    }
  };

  // Handlers optimizados
  const handleSearch = useMemo(
    () =>
      debounce((e) => {
        setFilters(prev => ({ ...prev, search: e.target.value, page: 1 }));
      }, 1000),
    []
  );

  const toggleSort = (field) => {
    setFilters(prev => ({
        ...prev,
        ordering: prev.ordering === `-${field}` ? field : `-${field}`
    }));
};

  const handleFieldToggle = (field) => {
    setSelectedFields(prev => 
      prev.includes(field) ? prev.filter(f => f !== field) : [...prev, field]
    );
  };

  if (error) return <Alert severity="error">Error al cargar alumnos</Alert>;
  if (isLoading) return <LoadingSkeleton />;
  
  // Al abrir el modal, copiar los campos seleccionados actuales al estado temporal
  const handleOpenFieldSelector = () => {
    setTempSelectedFields([...selectedFields]);
    SetConfigurationModalOpen(true);
  };

  // 2. Manejar cambios solo en el estado temporal
  const handleTempFieldToggle = (field) => {
    setTempSelectedFields(prev => 
      prev.includes(field) 
        ? prev.filter(f => f !== field) 
        : [...prev, field]
    );
  };

  // 3. Al confirmar, actualizar los campos seleccionados reales
  const handleApplyFields = () => {
    localStorage.setItem('selectedFields', JSON.stringify(tempSelectedFields));
    setSelectedFields(tempSelectedFields);
    SetConfigurationModalOpen(false);
  };

  // 4. Al cancelar, descartar cambios
  const handleCancelFields = () => {
    SetConfigurationModalOpen(false);
  };

  const handleRowClick = (alumno) => {
    setSelectedAlumnoId(alumno.id); // Solo guardar el ID
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false); // Cerrar el modal
    setSelectedAlumno(null); // Limpiar el alumno seleccionado
  };

  const modalStyles = {
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1300, // Material-UI usa hasta 1200 para sus componentes
    },
    modalContent: {
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      maxWidth: '800px',
      width: '90%',
      maxHeight: '90vh',
      overflowY: 'auto',
    }
  };

  const PaginationControls = () => {
    const totalPages = Math.ceil(totalCount / pageSize);
    
    return (<>
      <div className="d-flex justify-content-between align-items-center">

      <Pagination className="mt-3 justify-content-center m-auto">
        <Pagination.Prev 
          onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
          disabled={currentPage === 1}
        />
        
        {Array.from({ length: totalPages }, (_, i) => (
          <Pagination.Item
            key={i + 1}
            active={i + 1 === currentPage}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </Pagination.Item>
        ))}
        
        <Pagination.Next 
          onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
          disabled={currentPage >= totalPages}
        />
      </Pagination>
      <div className="ms-3">
        <span className="me-2">Mostrar:</span>
        <select 
            className="form-select form-select-sm d-inline-block w-auto"
            value={pageSize}
            onChange={(e) => {
                setPageSize(Number(e.target.value));
                setCurrentPage(1);
            }}
        >
          {[20, 50, 100, 150].map(size => (
              <option key={size} value={size}>{size}</option>
          ))}
      </select>
  </div>
  </div>
  </>
    );
  };

  return (
    <>
      <Paper 
        sx={{ p: 2, height: 'calc(100vh - 5rem)', display: 'flex', flexDirection: 'column', borderRadius: 0,
          backgroundColor: theme === 'dark' ? '#212529' : '#fff',
          color: theme === 'dark' ? '#fff' : '#000', }}
        >
        <Toolbar sx={{ gap: 2, margin:'auto', marginBottom:'1rem' }} >

          {/* Contador de alumnos mostrados */}
          <div style={{ minWidth: 190, fontWeight: 500 }}>
            Mostrando{' '}
            <span className='font-weight-bold '>
              {data?.results?.length || 0}
            </span>{' '}
            alumno{(data?.count === 1) ? '' : 's'}
          </div>
          {/* Botón para agregar nuevo alumno */}
        <Button 
          style={{ visibility: userRole === 'admin' ? 'visible' : 'hidden' }} // Solo visible para administradores
          variant="contained"
          color="primary"
          // startIcon={<Add />}
          onClick={() => {
            setSelectedAlumno(null); // Resetear alumno seleccionado
            setModalOpen(true);
          }}
          sx={{ 
            // minWidth: 120,
            maxWidth: '12rem',
            mx: 1,
            px: 1,
            '& .MuiButton-startIcon': {
              marginRight: '4px'
            }
          }}
          >
          Agregar Alumno
        </Button>
          <TextField
            variant="outlined"
            placeholder="Buscar..."
            slotProps={{ input: { startAdornment: <Search /> } }}
            onChange={handleSearch}
            size="small"
            InputProps={{
              style: {
                color: theme === "dark" ? "#fff" : "#000",
              },
              placeholder: "Buscar...",
              classes: {
                input: theme === "dark" ? "placeholder-dark" : "placeholder-light"
              }
            }}
            inputProps={{
              style: {
                '::placeholder': {
                  color: theme === "dark" ? "#bbb" : "#888",
                  opacity: 1
                }
              }
            }}
            className={`p-0 m-0  ${theme === "light" ? "" : "input-theme-black text-light"}`}
            data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
            style={{minWidth:'10%'}}
          />
          {/* Botón para limpiar todos los filtros */}
          
          <Tooltip title="Restablecer todos los filtros a valores por defecto">
            <Button
              style={{ visibility: hasActiveFilters ? 'visible' : 'hidden' }} // Solo visible si hay filtros activos
              variant={"outlined"}
              color={"primary"}
              onClick={() => {
                setFilters({
                  size:'small',
                  status: 'active',
                  showPaused: 'all',
                  search: '',
                  ordering: '-expiracion',
                  group: 'all',
                  trimester: 'all',
                  page: 1,
                  page_size: pageSize
                });
              }}
              startIcon={<FilterList />}
              sx={{ 
                '&:hover': {
                  backgroundColor: theme === 'light' ? 'rgba(90, 128, 231, 0.1)': '#363535', // Cambia el color de fondo al hacer hover
                },
                // minWidth: 120,
                maxWidth: '12rem',
                mx: 1,
                px: 1,
                '& .MuiButton-startIcon': {
                  marginRight: '4px'
                }
              }}
            >
              Limpiar Filtros
            </Button>
          </Tooltip>
          <FormControl variant="outlined" size="small" sx={{ minWidth: 120, mx: 1, py: 1 }}>
            <InputLabel
              style={{
                color: theme === "dark" ? "white" : "#000"
              }}
            >
              Estado
            </InputLabel>
            <Select
              value={filters.status}
              onChange={(e) => setFilters(prev => ({...prev, status: e.target.value}))}
              label="Estado"
              className={` ${theme === "light" ? "" : "input-theme-black text-light"}`}
              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
            > 
              <MenuItem value="all">Todos</MenuItem>
              <MenuItem value="active">Activos</MenuItem>
              <MenuItem value="inactive">Inactivos</MenuItem>
            </Select>
          </FormControl>

          <FormControl variant="outlined" size="small" sx={{ minWidth: 120, mx: 1, py: 1 }}>
            <InputLabel
              style={{
                color: theme === "dark" ? "white" : "#000"
              }}
            >Participación</InputLabel>
            <Select
              value={filters.showPaused}
              onChange={(e) => setFilters(prev => ({...prev, showPaused: e.target.value}))}
              label="Pausado"
              className={` ${theme === "light" ? "" : "input-theme-black text-light"}`}
              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
            > 
              <MenuItem value="all">En proceso + Pausados</MenuItem> 
              <MenuItem value="active">En proceso</MenuItem>
              <MenuItem value="paused">Pausados</MenuItem>
            </Select>
          </FormControl>
          <FormControl variant="outlined" size="small" sx={{ minWidth: 120, mx: 1, py: 1 }}>
            <InputLabel
              style={{
                color: theme === "dark" ? "white" : "#000"
              }}
            >Trimestre</InputLabel>
            <Select
              value={filters.trimester}
              onChange={(e) => setFilters(prev => ({...prev, trimester: e.target.value}))}
              // label=""
              className={` ${theme === "light" ? "" : "input-theme-black text-light"}`}
              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
            > 
              <MenuItem value="all">Todos</MenuItem> 
              <MenuItem value="1">1</MenuItem>
              <MenuItem value="2">2</MenuItem>
              <MenuItem value="3">3</MenuItem>
              <MenuItem value="4">4</MenuItem>
            </Select>
          </FormControl>
          <FormControl variant="outlined" size="small" sx={{ minWidth: 120, mx: 1, py: 1 }}>
            <InputLabel
              style={{
                color: theme === "dark" ? "white" : "#000"
              }}
            >Grupo</InputLabel>
            <Select
              value={filters.group}
              onChange={(e) => setFilters(prev => ({...prev, group: e.target.value}))}
              // label=""
              className={` ${theme === "light" ? "" : "input-theme-black text-light"}`}
              data-bs-theme={`${theme === "light" ? "light" : "dark"}`}
            > 
              <MenuItem value="all">Todos</MenuItem> 
              <MenuItem value="A">A</MenuItem>
              <MenuItem value="B">B</MenuItem>
              <MenuItem value="C">C</MenuItem>
              <MenuItem value="D">D</MenuItem>
            </Select>
          </FormControl>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <IconButton onClick={handleOpenFieldSelector}
            className={` ${theme === "light" ? "" : "text-light"}`}
            aria-label="Configuración">
              <Settings />
            </IconButton>
            <p style={{ margin: 0 }}> Configuración</p>
          </div>
        </Toolbar>
        <TableContainer sx={{ flexGrow: 1, maxHeight: 'calc(100vh )' }}>
          <Table
            stickyHeader
            >
          
            <TableHead>
              <TableRow
              >
                {selectedFields.map(field => (
                  <TableCell key={field}>
                    <SortableHeader 
                      className="m-1"
                      field={field} 
                      currentOrder={filters.ordering}
                      onSort={toggleSort}
                    />
                  </TableCell>
                ))}
              </TableRow> 
            </TableHead>
            <TableBody
              >
              {data?.results?.map(alumno => {
                // Obtener la fecha actual en UTC
                const today = new Date();
                const todayUTC = new Date(Date.UTC(
                  today.getUTCFullYear(), 
                  today.getUTCMonth(), 
                  today.getUTCDate()
                ));
                
                // Crear fecha de inicio en UTC y establecerla al final del día (23:59:59.999)
                const fechaInicio = new Date(alumno.inicio_acceso);
                const endOfDayUTC = new Date(Date.UTC(
                  fechaInicio.getUTCFullYear(),
                  fechaInicio.getUTCMonth(),
                  fechaInicio.getUTCDate(),
                  23, 59, 59, 999
                ));
                const rowStyle = today <= endOfDayUTC ? { backgroundColor: '#588358' } : {};
                // console.log('hoy', todayUTC, '\n', endOfDayUTC); 
                return (
                  <TableRow 
                    key={alumno.id} 
                    hover 
                    onClick={() => handleRowClick(alumno)} 
                    sx={{ 
                      cursor: 'pointer',
                      ...rowStyle // Aplicar el estilo condicional
                    }}
                  >
                    {selectedFields.map(field => (
                      <AlumnoCell key={field} field={field} alumno={alumno} />
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <PaginationControls 
          currentPage={filters.page}
          hasNext={!!data?.next}
          onPageChange={page => setFilters(prev => ({ ...prev, page }))}
        /> */}
      { <PaginationControls />}

      <ConfigurationModal
        open={configurationModalOpen}
        fields={availableFields}
        selectedFields={tempSelectedFields}
        onFieldToggle={handleTempFieldToggle}
        onApply={handleApplyFields}
        onCancel={handleCancelFields}
      />
      </Paper>
      {/* Modal (fuera del Paper, al mismo nivel) */}
      {modalOpen && <AdminModal 
        isOpen={modalOpen} 
        onClose={() => {
          setModalOpen(false);
          setSelectedAlumnoId(null);
        }}
        alumno={alumnoCompleto}
        isLoadingAlumno={isLoadingAlumno}
        mode={selectedAlumnoId ? 'edit' : 'create'}
        />
      }
    </>
  );
};

// Componentes auxiliares
const SortableHeader = ({ field, currentOrder, onSort }) => {
  const isSorted = currentOrder === field || currentOrder === `-${field}`;
  const direction = currentOrder.startsWith('-') ? 'desc' : 'asc';
  
  return (
      <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
          <span>{fieldLabels[field]}</span>
          <IconButton onClick={() => onSort(field)} size="small">
              {isSorted ? (
                  direction === 'asc' ? <ArrowUpward /> : <ArrowDownward />
              ) : <span style={{ width: 24 }} />}
          </IconButton>
      </div>
  );
};
const AlumnoCell = ({ field, alumno }) => {
  const value = alumno[field];
  const theme = localStorage.getItem('theme') || 'light';
  const formatValue = () => {
    if (value === 'nan' || value === null || value === undefined) {
      return <p className={`${theme === 'dark' ? 'text-light':''}`}> - </p>;
    }
    switch(field) {
      case 'activo' :
        return <p className={`${theme === 'dark' ? 'text-light':''}`}>{value ? '✅ Activo' : '❌ Inactivo'}</p>
      case 'call_previa_nils':
        return <p className={`${theme === 'dark' ? 'text-light':''}`}> {value ? '✅' : '❌'} </p>
      case 'pausado':
        return <p className={`${theme === 'dark' ? 'text-light':''}`}> {value ?  '⏸️ Pausado' : '▶️ No'} </p>

      case 'expiracion': 
      case 'proximo_pago': {
          // Fechas en UTC
          const todayUTC = new Date();
          todayUTC.setUTCHours(0, 0, 0, 0); // Fecha actual en UTC (medianoche)
          
          const expirationDate = new Date(value);
          expirationDate.setUTCHours(0, 0, 0, 0); // Fecha de expiración en UTC (medianoche)
          
          // Diferencia en días (UTC)
          const diffInDays = Math.ceil((expirationDate - todayUTC) / (1000 * 60 * 60 * 24));
          
          let style = {};
          if (diffInDays <= 2) {
              style = { color: 'red' };
          } else if (field === 'expiracion' && diffInDays <= 7) {
              style = { color: '#ff9704' };
          } else if (diffInDays > 7 || (field === 'proximo_pago' && diffInDays <= 7)) {
              style = { color: theme === 'light' ? 'black' : 'white' };
          }

          return <span style={style}>{dayjs(value).utc().format('DD/MM/YYYY')}</span>;
      } //new Date(value).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })
      
      case 'dias_restantes':
      return <p className={`${theme === 'dark' ? 'text-light':''}`}>{value === 0 ? ' - ' : `${value} días`}</p>;
      case 'nivel':
      return <p className={`${theme === 'dark' ? 'text-light':''}`}>{value === 'NINGUNO' ? 'Sin nivel' : value}</p>;
      case 'email_importado':
      return value ? <a  className={`${theme === 'dark' ? 'text-light':''}`} href={`mailto:${value}`}>{value}</a> : <p  className={`${theme === 'dark' ? 'text-light':''}`}>Sin correo</p>
      case 'whatsapp':
      return value ? (
        <a 
          href={`https://web.whatsapp.com/send/?phone=${value.replace(/[^\d]/g, '')}`} 
          target="_blank" 
          rel="noopener noreferrer"
        >
          {value}
        </a>
      ) : <p className={`${theme === 'dark' ? 'text-light':''}`} >Sin WhatsApp</p>;
      case 'user':
        return <p className={`${theme === 'dark' ? 'text-light':''}`} >{alumno.user?.username ? alumno.user?.username : 'Sin usuario' } </p> ;
      case 'encuesta':
        return value ? <a href={value} target="_blank" rel="noopener noreferrer">Ver encuesta</a> : 'Sin encuesta';
      case 'inicio_acceso':
      // case 'proximo_pago':
        return <p className={`${theme === 'dark' ? 'text-light':''}`}>{value 
          ? dayjs(value).format('DD/MM/YYYY')
          : 'Sin fecha'}</p>
      default:
      // console.log('Campo no formateado:', field, value);
        return <p className={`${theme === 'dark' ? 'text-light':''}`}>{value}</p>;
    }
  };

  return <TableCell>{formatValue()}</TableCell>;
};

const LoadingSkeleton = () => {
  const theme = localStorage.getItem('theme') === 'dark' ? '#363535' : '#f5f5f5';
  return (
    <div style={{ padding: 20, backgroundColor: theme }}>
      {[...Array(20)].map((_, i) => (
        <Skeleton key={i} variant="rectangular" height={40} sx={{ mb: 1 }} />
      ))}
    </div>
  );
};

// const ConfigurationModal = ({ 
//   open,
//   fields,
//   selectedFields,
//   onFieldToggle,
//   onApply,
//   onCancel
// }) => (
//   <Dialog open={open} onClose={onCancel}>
//     <DialogTitle>Seleccionar campos a mostrar</DialogTitle>
//     <DialogContent>
//       {fields.map(field => (
//         <FormControlLabel
//           key={field}
//           control={
//             <Checkbox
//               checked={selectedFields.includes(field)}
//               onChange={() => onFieldToggle(field)}
//               color="primary"
//             />
//           }
//           label={fieldLabels[field] || field}
//         />
//       ))}
//     </DialogContent>
//     <DialogActions>
//       <Button onClick={onCancel} color="primary">
//         Cancelar
//       </Button>
//       <Button onClick={onApply} color="primary" variant="contained">
//         Aplicar
//       </Button>
//     </DialogActions>
//   </Dialog>
// );
export default AlumnosList;